import styled from 'styled-components';
import { StyledAppOSCompatibilityProps } from './AppOSCompatibility.types';

export const StyledAppOSCompoatibility = styled.div<StyledAppOSCompatibilityProps>`
  .app-os-compatibility__slot-li {
    list-style: none;
  }

  ${(props) => props.customStyle}
`;
